import * as THREE from "three";


export class Button extends THREE.Group {

  protected _touchAreaIndicator: THREE.Mesh
  protected _isTouched: boolean = false

  protected _testMaterial: THREE.MeshBasicMaterial= new THREE.MeshBasicMaterial({color: 0xff0000, wireframe: true, transparent: true, opacity: 0.25});
  protected _touchMaterial: THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial({color: 0x00ff00, wireframe: true, transparent: true, opacity: 0.75});

  // private _lollipop: LollipopHelper = new LollipopHelper()

  protected _touchDistance: number = 0.1

  public get touchDistance(): number {
    return this._touchDistance
  }
  public set touchDistance(value: number) {
    this._touchDistance = value
    this._touchAreaIndicator.scale.setScalar(this._touchDistance*5.75)
  }

  public get isTouched(): boolean {
    
    return this._isTouched
  }

  protected _pressDelay = 0.5;
  protected _pressDelayTimer: number = 0;

  public set showDebug(value: boolean) {
    this._touchAreaIndicator.visible = value
  }

  public set isTouched(value: boolean) {
    if (this._pressDelayTimer > 0) {
      return;
    }
    this._touchAreaIndicator.material = value ? this._touchMaterial : this._testMaterial
    // this._lollipop.visible = value

    
    if (!this._isTouched && value){
      // console.log('button pressed')
      
      if (this._pressDelayTimer <= 0) {
        this._buttonAction()
        this._pressDelayTimer = this._pressDelay;
        if (this._selectSound) {
          this._selectSound.stop()
          this._selectSound.play()
        }
      }
    }

    if (this._isTouched && !value){
      // released
    }
    
    this._isTouched = value
  }

  protected _buttonAction: () => void = () => {
    console.error('buttonAction not set')
  };

  public set buttonAction(value: () => void) {
    this._buttonAction = value
  }

  private _selectSound?: THREE.PositionalAudio;


  stopSelectSound() {
    if (this._selectSound?.isPlaying) {
      this._selectSound.stop()
    }
  }

  addSelectSound(audioBuffer: AudioBuffer, audioListener: THREE.AudioListener) {
    this._selectSound = new THREE.PositionalAudio(audioListener)
    this._selectSound.setBuffer(audioBuffer)
    this._selectSound.setVolume(0.5)
    this._selectSound.setRefDistance(1)
    this._selectSound.setRolloffFactor(1)
    this._selectSound.setMaxDistance(100)
    this.add(this._selectSound)
  }

    constructor() {
        super()
        this._touchAreaIndicator = new THREE.Mesh(new THREE.SphereGeometry(1, 6, 2), this._testMaterial)
        this._touchAreaIndicator.rotateOnAxis(new THREE.Vector3(1, 0, 0), Math.PI/2)
        this.add(this._touchAreaIndicator)

        this._touchAreaIndicator.scale.setScalar(this._touchDistance*5.75)

        this._touchAreaIndicator.visible = false;
        // this.renderOrder = 100;
    }

    updateDelta(delta: number) {
      // super.update(delta)
      if (this._pressDelayTimer > 0) {
        Math.max(0, this._pressDelayTimer -= delta)
      }
    }

}
